import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
var swiper = new Swiper(".section1 .swiper", {
    navigation: {
        nextEl: ".section1 .swiper .swiper-button-next",
        prevEl: ".section1 .swiper .swiper-button-prev",
    },
    autoplay: {
        delay: 4000,
        disableOnInteraction: false,
    },
    speed:500,
    loop:true,//必须
});

if ( window.innerWidth> 1024) {
    $(window).on('scroll', function() {
        var scrollPosition = $(window).scrollTop(); // 获取当前滚动位置
        var modulePosition = $('.section2').offset().top; // 获取目标模块的顶部位置
        // 检查是否滚动到了模块的顶部或底部（根据需要选择）
        if(scrollPosition >= modulePosition && scrollPosition < $(".section2 ul li:last").offset().top) {
            $(".section2 .text").addClass("fixed");
            $(".section2 .text").removeClass("fixed1");
        }else if(scrollPosition >= $(".section2 ul li:last").offset().top) {
            $(".section2 .text").removeClass("fixed");
            $(".section2 .text").addClass("fixed1");
        }else if(scrollPosition < modulePosition) {
            $(".section2 .text").removeClass("fixed");
            $(".section2 .text").removeClass("fixed1");
        }
    });
  }

